/* eslint-disable @typescript-eslint/no-explicit-any */
import { enableProdMode } from '@angular/core';
import { environment } from '@mri-platform/shared/core';
import '@mri/elements-common';
import { OAuthErrorEvent } from 'angular-oauth2-oidc';
import { GetConfig } from './environment-assets/config';

declare global {
  interface Window {
    __settings: unknown;
  }
}

if (environment.production) {
  enableProdMode();
} else if (environment.dev) {
  import('rxjs-spy').then(rxjsSpy => {
    console.log(
      '[rxjsSpy] Added to window. To enable logging of tagged observables, at the console window type: `rxjsSpy.create(); spy.log()`'
    );
    console.log('[rxjsSpy] For more information see: https://github.com/cartant/rxjs-spy');
    Object.assign(window, { rxjsSpy });
  });
}

GetConfig()
  .then(_ => import('./bootstrap'))
  .catch((err: any) => {
    if (err as OAuthErrorEvent) {
      err.isSilent = true;
    }
  });
